import { parseJson } from '../../../utils/safeJson'

export const DEFAULT_ALARM_POINT_ICON = {
  color: '#989898',
  name: 'mdi mdi-alert-outline',
}

export function normalizeAlarmPointIcon(icon, fallback = DEFAULT_ALARM_POINT_ICON) {
  const parsedIcon = parseJson(icon, icon)

  if (parsedIcon && typeof parsedIcon === 'object' && !Array.isArray(parsedIcon)) {
    return {
      ...fallback,
      ...parsedIcon,
    }
  }

  return { ...fallback }
}

export function normalizeAlarmPointDto(alarmPoint, options = {}) {
  const normalized = alarmPoint && typeof alarmPoint === 'object' ? { ...alarmPoint } : {}

  if (options.stringifyId && normalized.id !== null) {
    normalized.id = String(normalized.id)
  }

  normalized.icon = normalizeAlarmPointIcon(normalized.icon)

  return normalized
}

export function isLifesignEnabled(value) {
  if (value === null || typeof value === 'undefined' || value === false || value === '') {
    return false
  }

  const interval = Number(value)
  return Number.isFinite(interval) && interval > 0
}

export function normalizeEnabledLifesignInterval(value) {
  return isLifesignEnabled(value) ? value : 1
}

export function isPersistedAlarmPointId(id) {
  if (id === null || typeof id === 'undefined' || id === '') {
    return false
  }

  if (typeof id === 'string') {
    return id !== 'new' && id !== 'null' && !id.startsWith('_')
  }

  return true
}

export function createAlarmPointDraft(overrides = {}) {
  return normalizeAlarmPointDto({
    id: null,
    version: 0,
    orgId: null,
    orgName: '',
    text: '',
    description: null,
    mediaUsageType: 'ALL',
    acknowledgeMode: 'NONE',
    confirmPriority: 1,
    mediaProcessingType: 'BY_RANK',
    instructionFile: null,
    speechText: null,
    localAcknowledgeTime: 0,
    countRepeat: 0,
    repeatBetween: 0,
    systemId: null,
    active: true,
    triggering: 'WHEN_ON',
    name: null,
    repeatMonInterval: 0,
    individualCalendarId: null,
    rotationalCalendarId: null,
    alarmPlanId: null,
    alarmRuleId: null,
    consequentialAlarms: [],
    alarmPointId: '',
    icon: DEFAULT_ALARM_POINT_ICON,
    ...overrides,
  })
}
